import React, { FC } from 'react'

const ProductRow:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/product-row.png" alt=''/>
        </div>
    </div>
  )
}

export default ProductRow